import { defineComponent as t, openBlock as l, createBlock as n, unref as a, mergeProps as p, withCtx as s, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCrossSmall",
  __name: "IconCrossSmall",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (i, e) => (l(), n(a(c), p(r, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M6.47 6.47a.75.75 0 0 1 1.06 0L12 10.94l4.47-4.47a.75.75 0 1 1 1.06 1.06L13.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06L12 13.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06L10.94 12 6.47 7.53a.75.75 0 0 1 0-1.06",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
